import { useParams } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';
import ProfileRow from './ProfileRow';
import { host } from './env';
import CanvasItem from './avwapp.chart';

export interface TickerDetail {
  profile: any;
  shortTermDailyChart: any;
  longTermDailyChart: any;
  intradayChart: any;
  symbolInfo: any;
}

const TickerDetailPage: React.FC = () => {
  const { symbol } = useParams();
  const [detail, setDetail] = useState<TickerDetail | null>(null);
  const [latestPriceChange, setLatestPrice] = useState<number | -1>(-1);


  useEffect(() => {
    if (!symbol) return;

    fetch(`${host}/getTicker?ticker=${encodeURIComponent(symbol)}`)
      .then((res) => res.json())
      .then((data) => setDetail(data))
      .catch((err) => {
        console.error('Error loading ticker detail:', err);
      });
  }, [symbol]);

  return (
    <div>
      <h3 className="ticker-detail">{symbol}</h3>
      {detail && detail.profile && symbol && detail.shortTermDailyChart && (
        <div>
          <ProfileRow profile={detail.profile} ticker={symbol} symbolInfo ={detail.symbolInfo} />

          <h3 className="ticker-detail"> 3 month daily, 21 SDMA </h3>

          <CanvasItem
           
            width={400}
            height={250}
            index={1}
            latestPrice={latestPriceChange}
            ticker={symbol}
            title={'90 day daily with 21-day sma'}
            onPriceChange={price => setLatestPrice(price)}
            chartData={detail.shortTermDailyChart}
          />

          <h3 className="ticker-detail"> 200 day daily, 50-day sma </h3>

          <CanvasItem
           
            width={400}
            height={250}
            index={1}
            latestPrice={latestPriceChange}
            ticker={symbol}
            title={'200 day daily with 50-day sma'}
            onPriceChange={price => setLatestPrice(price)}
            chartData={detail.longTermDailyChart}
          />
          <h3 className="ticker-detail"> 15 day 30-min chart, 5-day sma </h3>

          <CanvasItem
           
            width={400}
            onPriceChange={price => setLatestPrice(price)}
            height={250}
            index={1}
            latestPrice={latestPriceChange}
            ticker={symbol}
            title={'15 day 30min chart with 5-day sma'}
            chartData={detail.intradayChart}
          />
        </div>
      )}
    </div>
  );
};

export default TickerDetailPage;
